// import './App.css';
import { Routes, Route } from "react-router-dom";
import AboutUs from "./Frontend/Pages/AboutUs";
import Home from "./Frontend/Pages/Home";
import Navbar from "./Frontend/Navbar/Navbar";
import Footer from "./Frontend/Pages/Footer"; // Ensure this import matches your file naming
import IraqOffice from "./Frontend/Offices/IraqOffice";
import UKOffices from "./Frontend/Offices/UKOffices";
import Clearance from "./Frontend/Service/Clearance";
import RoadTransport from "./Frontend/Service/RoadTransport";
import TheRest from "./Frontend/Service/TheRest";
import Wholesale from "./Frontend/Service/Wholesale";
import Payment from "./Frontend/WhatWeOffer/Payment";
import LowestPrice from "./Frontend/WhatWeOffer/LowestPrice";
import PrivacyPolicy from "./Frontend/Privacy/PrivacyPolicy";
import TermsAndConditions from "./Frontend/Privacy/TermsAndConditions";
import NotFound from "./Frontend/Pages/NotFound";
import LocalDelivery from "./Frontend/Service/LocalDelivery";
import i18n from "./i18n";
import { useEffect } from "react";
function App() {
  useEffect(() => {
    i18n.changeLanguage("en");
  }, []);
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="AboutUs" element={<AboutUs />} />
          <Route path="IraqOffice" element={<IraqOffice />} />
          <Route path="UKOffices" element={<UKOffices />} />
          <Route path="Customs_Clearance" element={<Clearance />} />
          <Route path="RoadTransport " element={<RoadTransport />} />
          <Route path="Export_Services" element={<TheRest />} />
          <Route path="Wholesale_Distribution" element={<Wholesale />} />
          <Route
            path="Logistics_Storage_Solutions"
            element={<LocalDelivery />}
          />

          <Route
            path="International_Transportation"
            element={<LowestPrice />}
          />
          <Route path="Payment" element={<Payment />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
